import { FC } from 'react';

import { usePage } from '@inertiajs/react';
import { ArrowRight } from 'lucide-react';

import {
    calculateServiceFeeCents,
    formatServiceFeeMoney,
    ServiceFeePageProps,
} from '../../../components/shared/serviceFeePresentation';

interface Props {
    applicable: boolean;
    currentFeeCents: number;
    newTotal: number;
}

export const OrderServiceFeePreview: FC<Props> = ({
    applicable,
    currentFeeCents,
    newTotal,
}) => {
    const { serviceFeeAnnouncement } = usePage<ServiceFeePageProps>().props;

    if (!applicable) {
        return (
            <p className="mb-3 text-sm text-muted-foreground">
                Сервісний збір не застосовується до цього замовлення.
            </p>
        );
    }
    if (!serviceFeeAnnouncement) return null;

    const newFeeCents = calculateServiceFeeCents(
        newTotal,
        serviceFeeAnnouncement,
    );
    const feeChanged = currentFeeCents !== newFeeCents;

    return (
        <div className="mb-3 rounded-xl border bg-muted/20 p-3 text-sm">
            <div className="flex flex-wrap items-center justify-between gap-2">
                <span className="text-muted-foreground">
                    Сервісний збір після завершення:
                </span>
                <span className="flex items-center gap-2 font-semibold">
                    {formatServiceFeeMoney(currentFeeCents)}
                    {feeChanged && (
                        <>
                            <ArrowRight className="h-4 w-4 text-muted-foreground" />
                            <span className="text-primary">
                                {formatServiceFeeMoney(newFeeCents)}
                            </span>
                        </>
                    )}
                </span>
            </div>
            {feeChanged && (
                <p className="mt-1 text-xs text-muted-foreground">
                    Покупець побачить нову суму до підтвердження, а збір буде
                    списано з вашого балансу лише після завершення замовлення.
                </p>
            )}
        </div>
    );
};
